.woodTexture {
    background-image: url("../../../static/img/wood-texture.jpg");
}

.lighthouse {
    background-image: url("../../../static/img/lighthouse-v6.jpg");
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
}

.fadedShoreline {
    background-image: url("../../../static/img/faded-shoreline.jpg");
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
}

.militaryMonday {
    background-image: url("../../../static/img/military-monday.jpg");
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
    min-height: 100vh;
    padding-bottom: 900px;
    position: relative;

    & * {
        color: var(--color-white);
    }

    &::after {
        background-image: url("../../../static/img/militarymonday_plate.png");
        background-position: top right;
        background-repeat: no-repeat;
        background-size: contain;
        bottom: 0;
        content: "";
        display: block;
        height: 823px;
        position: absolute;
        right: 0;
        width: 100%;
    }
}

.lobster {
    background-color: var(--color-lobster);

    & * {
        color: var(--color-white);
    }
}

.blueChill {
    background-color: var(--color-blue-chill);

    & * {
        color: var(--color-white);
    }
}
